import React from "react";
import { Badge, Tooltip } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

interface ConnectionStatusProps {
  isConnected: boolean;
  isConnecting?: boolean;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  isConnected,
  isConnecting = false,
}) => {
  const getStatus = () => {
    if (isConnecting) {
      return {
        icon: <LoadingOutlined style={{ fontSize: 16, color: "#faad14" }} />,
        text: "Connecting to real-time updates...",
        color: "processing",
      };
    }

    if (isConnected) {
      return {
        icon: <CheckCircleOutlined style={{ fontSize: 16, color: "#52c41a" }} />,
        text: "Connected to real-time updates",
        color: "success",
      };
    }

    return {
      icon: <CloseCircleOutlined style={{ fontSize: 16, color: "#ff4d4f" }} />,
      text: "Disconnected from real-time updates",
      color: "error",
    };
  };

  const status = getStatus();

  return (
    <Tooltip title={status.text}>
      <div
        role="status"
        aria-live="polite"
        aria-label={status.text}
        style={{ cursor: "default" }}
      >
        <Badge
          status={status.color as any}
          text={
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              {status.icon}
              <span style={{ fontSize: 12 }}>
                {isConnecting ? "Connecting" : isConnected ? "Live" : "Offline"}
              </span>
            </span>
          }
        />
      </div>
    </Tooltip>
  );
};
